import React, { useEffect, useState } from 'react';
import GenericDialogue from 'src/components/Dialogue/Dialogue';
import NewBadge from 'src/components/NewBadge/NewBadge';
import Callout from 'src/components/InformationCallout/Callout';
import RadioButtonGroup from 'src/components/RadioButtonGroup/RadioButtonGroup';
import Button from 'src/components/Button';
import { ITEMS_PER_PAGE_OPTIONS } from 'src/SharedCustomHooks/UseTablePagination/useTablePagination';

interface RadioOption {
  value: string;
  label: string;
}

const RADIO_OPTIONS: RadioOption[] = ITEMS_PER_PAGE_OPTIONS.map((option: number) => ({
  value: String(option),
  label: String(option),
}));

interface ItemsPerPageDialogueProps {
  isOpen: boolean;
  onClose: () => void;
  currentValue: number;
  onSave: (next: number) => void;
}

export const ItemsPerPageDialogue = ({
  isOpen,
  onClose,
  currentValue,
  onSave,
}: ItemsPerPageDialogueProps) => {
  const [draftValue, setDraftValue] = useState<string>(String(currentValue));

  useEffect(() => {
    if (isOpen) {
      setDraftValue(String(currentValue));
    }
  }, [isOpen, currentValue]);

  const handleSave = () => {
    onSave(Number(draftValue));
    onClose();
  };

  return (
    <GenericDialogue
      isOpen={isOpen}
      onClose={onClose}
      title={
        <>
          Items per page
          <NewBadge spaced />
        </>
      }
      maxWidth="55rem"
      footer={
        <>
          <Button
            color="teal"
            size="small"
            label="Cancel"
            outlined
            onClick={onClose}
          />
          <Button
            color="teal"
            size="small"
            label="Save"
            onClick={handleSave}
          />
        </>
      }
    >
      <Callout
        variant="info"
        title="Change how many rows show per page."
        subtitle="Pick a size that suits how you like to scan a table. This applies to every paginated table in Juniper, and you can change it any time."
      />
      <RadioButtonGroup
        name="itemsPerPage"
        options={RADIO_OPTIONS}
        value={draftValue}
        onChange={setDraftValue}
        direction="horizontal"
      />
    </GenericDialogue>
  );
};

export default ItemsPerPageDialogue;